var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useNotify } from "react-admin";
import { useTranslation } from "react-i18next";
import { Dialog } from "@sequentech/ui-essentials";
import { IconButton, TextField, Tooltip, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
export var DecryptHelp = function (_a) {
    var decryptionCommand = _a.decryptionCommand;
    var notify = useNotify();
    var t = useTranslation().t;
    var handleCopyPassword = function () {
        navigator.clipboard
            .writeText(decryptionCommand)
            .then(function () {
            notify(t("electionEventScreen.export.copiedSuccess"), {
                type: "success",
            });
        })
            .catch(function (err) {
            notify(t("electionEventScreen.export.copiedError"), {
                type: "error",
            });
        });
    };
    return (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ sx: { whiteSpace: "pre-wrap" } }, { children: t("reportsScreen.messages.decryptInstructions") })), _jsx(TextField, { fullWidth: true, value: decryptionCommand, multiline: true, InputProps: {
                    readOnly: true,
                    endAdornment: (_jsx(Tooltip, __assign({ title: t("electionEventScreen.import.passwordDialog.copyPassword") }, { children: _jsx(IconButton, __assign({ onClick: handleCopyPassword }, { children: _jsx(ContentCopyIcon, {}) })) }))),
                } })] }));
};
export var PasswordDialog = function (_a) {
    var password = _a.password, onClose = _a.onClose, children = _a.children;
    var t = useTranslation().t;
    var notify = useNotify();
    var handleCopyPassword = function () {
        navigator.clipboard
            .writeText(password)
            .then(function () {
            notify(t("electionEventScreen.export.copiedSuccess"), {
                type: "success",
            });
        })
            .catch(function (err) {
            notify(t("electionEventScreen.export.copiedError"), {
                type: "error",
            });
        });
    };
    return (_jsxs(Dialog, __assign({ variant: "info", open: true, handleClose: onClose, "aria-labelledby": "password-dialog-title", title: t("electionEventScreen.export.passwordTitle"), ok: "Ok" }, { children: [t("electionEventScreen.export.passwordDescription"), _jsx(TextField, { fullWidth: true, margin: "normal", value: password, InputProps: {
                    readOnly: true,
                    endAdornment: (_jsx(Tooltip, __assign({ title: t("electionEventScreen.import.passwordDialog.copyPassword") }, { children: _jsx(IconButton, __assign({ onClick: handleCopyPassword }, { children: _jsx(ContentCopyIcon, {}) })) }))),
                } }), children] })));
};
